import React from 'react';
import dynamic from 'next/dynamic';
import { HoverCard } from '../hover-card';

const HoverCardTrigger = dynamic(() => import('../hover-card').then(mod => mod.HoverCard.Trigger), {
  ssr: false,
});

const StyledHoverContent = dynamic(
  () => import('../hover-card').then(mod => mod.StyledHoverContent),
  { ssr: false },
);

export const UserHoverCard = ({
  trigger,
  userHoverCardContent,
  triggerAsChild = false,
}: {
  trigger: React.ReactNode;
  userHoverCardContent: React.ReactNode;
  triggerAsChild?: boolean;
}) => {
  const triggerRef = React.useRef<HTMLAnchorElement>(null);

  return (
    <HoverCard closeDelay={100} openDelay={200}>
      <HoverCardTrigger ref={triggerRef} style={{ minWidth: 0 }} asChild={triggerAsChild}>
        {trigger}
      </HoverCardTrigger>

      <StyledHoverContent
        className="p-0"
        sideOffset={8}
        onPointerDownOutside={event => {
          if (event.target === triggerRef.current) event.preventDefault();
        }}
      >
        {userHoverCardContent}
      </StyledHoverContent>
    </HoverCard>
  );
};
